/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { UsePagination } from '@/components/blocks/UsePagination';
import { UsePaginationSkeleton } from '@/components/blocks/UsePagination/UsePaginationSkeleton';
import { useCatalogEntryList } from '@/data/Content/CatalogEntryList';
import { ContentContext } from '@/data/context/content';
import { Grid } from '@mui/material';
import { ChangeEvent, FC, useCallback, useContext } from 'react';

export const CatalogEntryListPagination: FC = () => {
	const { pageCount, pageNumber, onPageChange, loading } = useContext(ContentContext) as ReturnType<
		typeof useCatalogEntryList
	>;
	const onChange = useCallback(
		(_: ChangeEvent<unknown>, page: number) => {
			onPageChange(page);
			window.scrollTo({ top: 0, behavior: 'smooth' });
		},
		[onPageChange]
	);

	return (
		<Grid sx={{ my: '28px', pt: '16px', borderTop: '1px solid #D9D9D9' }}>
			{loading ? <UsePaginationSkeleton /> : null}
			{!loading && pageCount && pageCount > 1 ? (
				<UsePagination count={pageCount} onChange={onChange} defaultPage={pageNumber} />
			) : null}
		</Grid>
	);
};
